module.exports = __webpack_public_path__ + "assets/img/evaluation_identify.6185f66e.jpg";